import styled, { css } from 'styled-components';
import { breakpoints } from 'theme';

export const DocIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TabLabel = styled.span``;

export const CommentIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledTab = styled.li`
  &:not(:last-child) {
    margin-right: ${({ isSidebar, marginRight }) =>
      isSidebar ? '5px' : marginRight ? marginRight : '25px'};
  }

  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  position: relative;
  color: ${({ theme }) => theme.color.baliHai};
  white-space: nowrap;
  ${DocIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.baliHai};
      }
    }
  }
  ${CommentIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.baliHai};
      }
    }
  }
  &:hover {
    color: ${({ theme }) => theme.color.white};
    background-color: ${({ theme }) => theme.color.brightTurquoise};
    ${DocIconWrapper} {
      & > svg {
        path {
          fill: ${({ theme }) => theme.color.white};
        }
      }
    }
    ${CommentIconWrapper} {
      & > svg {
        path {
          fill: ${({ theme }) => theme.color.white};
        }
      }
    }
  }

  border-radius: 24px;
  border: none;

  @media ${breakpoints.smPlus} {
    padding: ${({ isSidebar }) => (isSidebar ? '6px' : '10px')};
    margin: ${({ isSidebar }) => (isSidebar ? '2px 10px' : 'auto 0px')};
    transition: 0.25s;
  }

  @media ${breakpoints.downSmPlus} {
    padding: 2px 10px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${({ theme }) => theme.color.white};
      background-color: ${({ theme }) => theme.color.brightTurquoise};
      ${DocIconWrapper} {
        & > svg {
          path {
            fill: ${({ theme }) => theme.color.white};
          }
        }
      }
      ${CommentIconWrapper} {
        & > svg {
          path {
            fill: ${({ theme }) => theme.color.white};
          }
        }
      }
    `}
`;

export const StyledItemPlaceholder = styled.div`
  flex-grow: 1;
`;
